import React from "react";
import { useDispatch } from "react-redux";
import { change } from "redux-form";

import { changeFilterParams } from "jazasoft";

import OrderHome from "../../OrderHome";
import hasPrivilege from "../../../utils/hasPrivilege";
import Forbidden from "../../../components/Forbidden";
import { ResourceId, Scope } from "../../../utils/privilege";

// const getMicroReportId = page => {
//   switch (page) {
//     case "reconciliation":
//       return MicroReportId.RECONCILIATION;
//     case "cutplan":
//       return MicroReportId.CUT_PLAN;
//     case "rollplan":
//       return MicroReportId.ROLL_PLAN;
//     case "fabricRelease":
//       return MicroReportId.FABRIC_RELEASE;
//     case "layslipFeedback":
//       return MicroReportId.LAYSLIP_FEEDBACK;
//     case "partsRecutting":
//       return MicroReportId.PART_RECUTTING;
//     case "garmentRecutting":
//       return MicroReportId.GARMENT_RECUTTING;
//     case "bundle":
//       return MicroReportId.BUNDLE_TICKET;
//     default:
//       return;
//   }
// };

const MicroHome = ({ report, filterDefaultValues, ...props }) => {
  const dispatch = useDispatch();

  /* eslint-disable react-hooks/exhaustive-deps */
  React.useEffect(() => {
    dispatch(changeFilterParams("orders", filterDefaultValues));
    dispatch(change("filter-form", "stateValue", filterDefaultValues?.stateValue));
  }, [dispatch, report, JSON.stringify(filterDefaultValues)]);

  // const page = props.location && props.location.pathname && props.location.pathname.substring(props.location.pathname.lastIndexOf("/") + 1);
  if (!hasPrivilege(props.roles, props.hasAccess, ResourceId.MICRO, Scope.READ)) {
    return <Forbidden history={props.history} />;
  }
  return (
    <OrderHome
      name="orders"
      i18nKey="orders"
      resource="orders"
      rowClick={id => `/reports/micro/${report}/${id}/view`}
      filterDefaultValues={filterDefaultValues}
      {...props}
    />
  );
};

export default MicroHome;
